import type { ReactNode } from "react"
import { Loader2, ShieldAlert } from "lucide-react"

/**
 * Uma pergunta que quem está a ler tem de responder (0.37.0): associar um
 * código que não é um EAN, substituir a contagem pendente de outra pessoa no
 * Odoo. O mesmo desenho do `SerialActivationDialog`: por cima de tudo
 * (`z-[100]`, a câmara pode estar aberta), nunca decide por omissão — fechar
 * é «Cancelar».
 */
export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  cancelLabel = "Cancelar",
  busy = false,
  error,
  onConfirm,
  onCancel,
}: {
  title: string
  children: ReactNode
  confirmLabel: string
  cancelLabel?: string
  busy?: boolean
  error?: string | null
  onConfirm: () => void
  onCancel: () => void
}) {
  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-black/60 p-3 sm:items-center" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
      <div className="w-full max-w-md space-y-3 rounded-2xl bg-background p-4 text-foreground shadow-xl">
        <div className="flex items-start gap-2">
          <ShieldAlert className="mt-0.5 h-6 w-6 shrink-0 text-amber-600" />
          <h2 id="confirm-dialog-title" className="text-lg font-semibold leading-snug">
            {title}
          </h2>
        </div>
        <div className="space-y-2 text-base leading-relaxed">{children}</div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex flex-col gap-2 pt-1">
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="flex h-14 w-full items-center justify-center gap-2 rounded-xl bg-primary text-base font-semibold text-primary-foreground disabled:opacity-50"
          >
            {busy && <Loader2 className="h-5 w-5 animate-spin" />} {confirmLabel}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="flex h-12 w-full items-center justify-center rounded-xl border text-base font-medium active:bg-muted disabled:opacity-50"
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
